/*eslint no-script-url: 0 */
import React, { Component } from "react";
import MatItems from './MatItems';

export default class MatSelection extends Component {
    render() {
        const { selectedMatSize, error, matView } = this.props;
        if (error) {
            return <div className="col-sm-7 alert alert-danger">{error}</div>;
        } else {
            let matSize = '';
            if ( parseFloat(selectedMatSize) === 1 || parseFloat(matView) === 1 ) {
                matSize = 'top';
            } else if ( parseFloat(selectedMatSize) === 2 || parseFloat(matView) === 2 ) {
                matSize = 'middle';
            }

            return (
                <div className="col-sm-7">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4>Select your {matSize} mat</h4><br/>
                        </div>
                        <MatItems
                            {...this.props} />
                    </div>
                </div>
            );
        }
    }
}